import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/source-serif-4/400.css';
import '@fontsource/source-serif-4/600.css';
import { setupStaticThemeControls } from './design-system/theme-runtime';
// The public homepage is complete HTML. Only application routes need React,
// authentication, search parsers, drawers, and the rest of the app runtime.
import { hasPreviousLogin } from './lib/returningUser';
import { setupHomeInteractions } from './pages/home/interactions';
import { setupHomeLanguage } from './pages/home/home-language';

// React Router records explicit Home intent on this history entry, including reloads.
if (window.location.pathname !== '/' || window.history.state?.usr?.explicitHome === true) {
  void import('./main');
} else if (hasPreviousLogin()) {
  window.location.replace(`/cautare${window.location.search}${window.location.hash}`);
} else {
  setupHomeInteractions();
  setupStaticThemeControls();
  setupHomeLanguage();
}
